module.exports = __webpack_public_path__ + "static/img/ic_send.53de7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/pc/ic_send.png
// module id = /hTz
// module chunks = 10